import get from 'lodash/get'

export const isSurveysEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'surveys' && enabled === true)

}
